// extracted by mini-css-extract-plugin
export default {"buttonMain":"MainButton_buttonMain__xR6br","lg":"MainButton_lg__nj8Bs"};